import type { ComponentProps, ComponentType } from 'react';

import MuiChip from '@mui/material/Chip';
import RuntimeChip from '../../../node_modules/@sdb/ui/components/atoms/Chip/index';

type SdbChipProps = ComponentProps<typeof MuiChip> & {
  shape?: 'pill';
};

const Chip = RuntimeChip as unknown as ComponentType<SdbChipProps>;

export default function SdbChip(props: SdbChipProps) {
  return <Chip {...props} />;
}
